import useAccountManagementStore from "../stores/accountManagementStore";
import useDataStore from "../stores/dataStore";
import removeTableData from "./backend/table_database/removeTableData";
import getTextFilesForUser from "./backend/text_buckets/getTextFilesForUser";
import { MergeResult } from "./mergeTableData";

/**
 * Remove all deleted text files, tags, and folders from cloud
 * @param data The result of the merge operation
 */

export default function removeDataFromCloud(
    removeFromCloud: MergeResult["removeFromCloud"]
) {
    const userData = useAccountManagementStore.getState().userData;

    // If need to remove note, folder, or tag from database
    if (
        removeFromCloud.notes.length !== 0 ||
        removeFromCloud.folders.length !== 0 ||
        removeFromCloud.tags.length !== 0
    ) {
        //? When notes are removed from tableData, they are also removed from bucket in the backend
        removeTableData({ deletedData: removeFromCloud });

        // Remove all deleted text files, tags, and folders from data
        removeFromCloud.notes.forEach((removedID) => {
            useDataStore.getState().remove.note(removedID);
        });

        removeFromCloud.folders.forEach((removedID) => {
            useDataStore.getState().remove.folder(removedID);
        });
    }

    // Check if need to remove text files from cloud.
    if (!userData?.id || userData?.id === "default") return;
    // Get text files that exist in cloud
    getTextFilesForUser().then((cloudTextFiles) => {
        if (!cloudTextFiles || cloudTextFiles.length === 0 || !removeFromCloud)
            return;

        // Remove all deleted text files, tags, and folders from cloud
        removeFromCloud.notes.forEach((removedID) => {
            if (cloudTextFiles.includes(removedID))
                useDataStore.getState().remove.note(removedID);
        });
    });
}
